export enum GqlOperationPathEnum {
  GLOBAL = 'global',
  LOGIN = 'login',
  REGISTER = 'register',
}
